import { useSelector } from "react-redux";
import { isTestCaseForLien } from "../../../../lib/systemData";
import ClearDataTest from "../../page/ClearDataTest";
import TabHeader from "../../tab/TabHeader";
import LienDetails from "./LienDetails";
import LienHistory from "./LienHistory";
import NotesComponent from "../notes/NotesComponent";
import DoNotLienToggle from "./DoNotLienToggle";
import CreateLienFromDocument from "./CreateLienFromDocument";

export default function LienTab({ inWorkQ }) {
    const activeCase = useSelector(state => state.case.activeCase)

    return <>
        <TabHeader>
            <div className="flex-container flex-container-space-betwen">
                <div className="flex-container">
                    <h2>Lien</h2>
                    <NotesComponent noteTypeId={22} inWorkQ={inWorkQ}/>
                    <LienHistory inWorkQ={inWorkQ} />
                </div>
                <div className="flex-container">
                    <CreateLienFromDocument />
                    <DoNotLienToggle activeCase={activeCase} inWorkQ={inWorkQ} />
                    {isTestCaseForLien(activeCase) && <ClearDataTest type={'lien'} btnTitle={'Reset lien information'} />}
                </div>
            </div>
        </TabHeader>
        <div>
            <LienDetails />
        </div>
    </>
}